define(function(require) {

	const tpl = require('./templates/t_lov_payment_summary.hbs');
	const fees_list = require('./v_cpv_payment_summary');

	const ips_model = require('civicsBase/ipsModel');
	const view_manager = require('civicsUtils/view_manager');
	const utils = require('civicsUtils/general_utilities');
	const InternalChargeCollection = require('civicsCollections/internal_charge_collection');
	const AvailableFeatures = require('civicsUtils/available_features');
	const ConfirmationModal = require('civicsViews/core/confirmation/v_itv_confirmation');
	const modal_region = require('civicsUtils/modal_region.js');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			feeListRegion:'@ui.feeList',
			modalRegion: {
				selector: 'body .rhythm-modals',
				regionClass: modal_region,
			},
		},
		ui: {
			'feeList':'.fee-content',
			'makePaymentButton':'.payment-btn',
			'paymentCap': '.payment-cap',
			'summary':'.summary-total-fees'
		},
		events: {
			'click @ui.makePaymentButton':'makePaymentClicked',

		},
		className:"v_lov_payment_summary",
		views:{},
		initialize: function(options) {
			this.config = options.config;
			var feesConfig = view_manager.globalConfig().get('fees');
			this.paymentCapAmount = feesConfig? feesConfig.get('paymentCapAmount') : null;
			this.selectedFees = options.selectedFees;
			this.feesCollection = options.feesCollection;
			this.views.selectedFees = new fees_list({
				config:this.config,
				selectedFees:this.selectedFees,
				feesCollection:this.feesCollection
			});
			this.feesForValidationPromise = $.Deferred();
			this.selectedFees.on('change',_.bind(function(){this.checkButtonStatus()},this));
		},
		onShow:function(){
			this.feeListRegion.show(this.views.selectedFees);
			this.checkButtonStatus();
			this.$el.rhythmThemeInit();

			utils.removeCookie("OnetimePayment");
			utils.removeCookie("InstTargetPage");
			App.sessionStorage.remove('CIVICS', 'OTP_PAYMENT');
		},
		checkButtonStatus:function(){
			var coll = this.views.selectedFees.collection;
			var totalAmount = 0;
			coll.each(function(fee) {
				if (fee.get('checked')) {
					totalAmount+=Number(fee.get('totalUnpaidAmount'));
				}
			});
			if (totalAmount <= 0) {
				this.ui.makePaymentButton.attr('disabled','disabled');
				this.ui.paymentCap.hide();
			} else if (totalAmount <= this.paymentCapAmount || this.paymentCapAmount == 0) {
				this.ui.makePaymentButton.removeAttr('disabled');
				this.ui.paymentCap.hide();
			} else {
				this.ui.makePaymentButton.attr('disabled','disabled');
				this.ui.paymentCap.show();
			}
		},
		makePaymentClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}
			if(!this.ui.makePaymentButton.attr('disable')){
				this.validateSelectedFee();

				$.when(this.feesForValidationPromise).done(()=>{
					//Save the selected fee keys in the session Storage
					var feeList = '';
					this.selectedFees.each(function(fee){
						if (fee.get('checked')) {
							feeList += fee.id+','+fee.get('instrumentType')+';';
						}
					});
					App.sessionStorage.set('CIVICS', 'CHECKOUT_FEES', feeList);
					window.location = this.config.makePaymentURL;
				});

				
			}
		},
		// Validate whether the selected fees have an in-process transaction. 
		// Prevent payment of fees that are already in process.
		validateSelectedFee: function(){
			if(AvailableFeatures.ValidateInProcessFee()){
				this.fees = new InternalChargeCollection();
				var feesParam = {
					InternalCharges:[]
				};
				this.selectedFees.each(function(fee){
					if (fee.get('checked')) {
						feesParam.InternalCharges.push({
							"Key": fee.get('id'),
							"Token": fee.get('token')
						});
					}
				});
				this.fees.save(feesParam).done((response) => {
					let inProcessCount = response.data.filter((fees)=> fees.isInProcess).length;
					if(inProcessCount  > 0)
						this.showHasInProcessConfirmationModal(response.data);
					else
						this.feesForValidationPromise.resolve();
				});
			}else{
				this.feesForValidationPromise.resolve();
			}
		},
		showHasInProcessConfirmationModal(fees){
			let allFeesInProcess = fees.filter((fees)=> fees.isInProcess).length == fees.length;
			let message = i18n.t('CIVICS.MY_FEES_LIST.ERROR_MESSAGE.IN_PROCESS_FEES_WITH_VALID');
			let okButtonLabel = i18n.t('CIVICS.COMMON.YES');
			let showCancelButton = true;
			if(allFeesInProcess){ // all selected fees are in process
				message = fees.length > 1 ? i18n.t('CIVICS.MY_FEES_LIST.ERROR_MESSAGE.IN_PROCESS_FEES'):  i18n.t('CIVICS.MY_FEES_LIST.ERROR_MESSAGE.IN_PROCESS_FEE');
				okButtonLabel =  i18n.t('CIVICS.COMMON.CLOSE');
				showCancelButton = false;
			}

			view_manager.loading(false);
			var modal = new ConfirmationModal({
				title: i18n.t('CIVICS.COMMON.NOTIFICATION'),
				okLabel: okButtonLabel,
				message: message,
				modalRegion: this.modalRegion,
				cancelLabel: i18n.t('CIVICS.COMMON.NO'),
				showCancelButton: showCancelButton,
				okCallback: () => {
					if(!allFeesInProcess){
						view_manager.loading(true);
						let inProcessList = fees.filter((fees)=> fees.isInProcess);
						this.selectedFees.forEach((fee) => {
							_.forEach(inProcessList, (inProc)=>{
								if(inProc.applicationFeeKey ==fee.get('id')){
									fee.set('checked', false);
								}
							});
						});
						this.feesForValidationPromise.resolve();
					}
				}
			  });
			  this.modalRegion.show(modal);
			  this.modalRegion.showModal();
		},
		templateHelpers:function(){

		},
	});
});
